module.exports = __webpack_public_path__ + "static/media/departureService.383dc06d.png";